// extracted by mini-css-extract-plugin
export default {"card":"dashboard-comparison-card_card__31WkW"};